import i18next, { t as i18TFunc } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ArLocale } from './ar.locale.ts';
import { BnLocale } from './bn.locale.ts';
import { DeLocale } from './de.locale.ts';
import { EnLocale } from './en.locale.ts';
import { EsLocale } from './es.locale.ts';
import { FrLocale } from './fr.locale.ts';
import { HiLocale } from './hi.locale.ts';
import { ItLocale } from './it.locale.ts';
import { JaLocale } from './ja.locale.ts';
import { KoLocale } from './ko.locale.ts';
import { PtBrLocale } from './pt-br.locale.ts';
import { RuLocale } from './ru.locale.ts';
import { TrLocale } from './tr.locale.ts';
import { ZhLocale } from './zh.locale.ts';
import { GetLocalStorage, LocalStorageKeyName, SetLocalStorage } from '../util/local-storage.ts';

export interface LanguageConfig {
    code: string;
    display: string;
    resource: Record<string, string | object>;
    icon: string;
}

export const languages: LanguageConfig[] = [
    {
        code: 'en',
        display: 'English',
        resource: EnLocale,
        icon: '🇺🇸',
    },
    {
        code: 'es',
        display: 'Español',
        resource: EsLocale,
        icon: '🇪🇸',
    },
    {
        code: 'ja',
        display: '日本語',
        resource: JaLocale,
        icon: '🇯🇵',
    },
    {
        code: 'de',
        display: 'Deutsch',
        resource: DeLocale,
        icon: '🇩🇪',
    },
    {
        code: 'ko',
        display: '한국어',
        resource: KoLocale,
        icon: '🇰🇷',
    },
    {
        code: 'it',
        display: 'Italiano',
        resource: ItLocale,
        icon: '🇮🇹',
    },
    {
        code: 'pt-BR',
        display: 'Português (Brasil)',
        resource: PtBrLocale,
        icon: '🇧🇷',
    },
    {
        code: 'fr',
        display: 'Français',
        resource: FrLocale,
        icon: '🇫🇷',
    },
    {
        code: 'zh',
        display: '中文（简体）',
        resource: ZhLocale,
        icon: '🇨🇳',
    },
    {
        code: 'hi',
        display: 'हिन्दी',
        resource: HiLocale,
        icon: '🇮🇳',
    },
    {
        code: 'ar',
        display: 'العربية',
        resource: ArLocale,
        icon: '🇸🇦',
    },
    {
        code: 'ru',
        display: 'Русский',
        resource: RuLocale,
        icon: '🇷🇺',
    },
    {
        code: 'tr',
        display: 'Türkçe',
        resource: TrLocale,
        icon: '🇹🇷',
    },
    {
        code: 'bn',
        display: 'বাংলা',
        resource: BnLocale,
        icon: '🇧🇩',
    },
];

export function getCurrentLanguage() {
    const langCode = GetLocalStorage(LocalStorageKeyName.Language) || i18next.language;
    if (langCode?.toLowerCase() === 'pt') {
        return languages.find((lang) => lang.code === 'pt-BR');
    }
    return languages.find((lang) => lang.code === langCode);
}

function setPageTitle() {
    const newTitle = i18TFunc('page.txtTitle');
    document.title = newTitle;
}

i18next.use(initReactI18next).init({
    resources: languages.reduce((resourceMap, cur) => {
        resourceMap[cur.code] = {
            translation: cur.resource,
        };
        return resourceMap;
    }, {} as Record<string, any>),
    lng: getCurrentLanguage()?.code,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    }
}, () => {
    setPageTitle();
});

export function ChangeLanguage(newLanguage: LanguageConfig) {
    i18next.changeLanguage(newLanguage.code);
    setPageTitle();
    SetLocalStorage(LocalStorageKeyName.Language, newLanguage.code);
}
